import AddShop from "../symbols/addShop";
import { HttpRequestPost } from "../../service";
interface ShopFormI {
  Name?: string;
  Line1?: string;
  Line2?: string;
  PostalCode?: string;
  City?: string;
  County?: string;
}
const addShopAction = () => ({
  type: AddShop.ADD_SHOPS,
});
const addShopSuccessAction = (data: any) => ({
  type: AddShop.ADD_SHOPS_SUCCESS,
  payload: data,
});
const addShopFailureAction = (data: any) => ({
  type: AddShop.ADD_SHOPS_FAILURE,
  payload: data,
});
const clearAddShopAction = () => ({
  type: AddShop.CLEAR_ADD_SHOPS,
});

export function addShop(data: ShopFormI, callback?: (resp?: any) => void) {
  return (dispatch: any) => {
    const url = "/merchant/shop";
    dispatch(addShopAction());
    HttpRequestPost(
      url,
      dispatch,
      addShopSuccessAction,
      addShopFailureAction,
      true,
      data,
      callback
    );
  };
}

export function clearAddShop() {
  return (dispatch: any) => {
    dispatch(clearAddShopAction());
  };
}
